@if (isMultiColorLogo()) {
  <img [attr.data-le-code]="legalEntityCode" [class]="getMultiColorClass()" [src]="getMultiColorLogo()" />
} @else if (hasFallbackSvg()) {
  <img [attr.data-le-code]="legalEntityCode" [class]="getFallbackSvgClass()" [src]="getFallbackSvgSrc()" />
} @else {
  <mat-icon [style.color]="getMatIconColor()" [class]="getSingleColorClass()" [attr.data-icon-name]="getSingleColorLogo()">{{ getSingleColorLogo() }}</mat-icon>
}
